// 專欄文章 列表
"use client";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getColumnNewsByPage } from "@/app/actions";

import NewsComponent from "../basic/NewsComponent"; // 文章元件
import LoadMore from "../index/LoadMore"; // 載入更多

const ColumnArticleList = ({ locale, initialNews, authorName, pageCnt }) => {
  const { t } = useTranslation();
  const [loadingMore, setLoadingMore] = useState(false); // 載入更多
  const [newsList, setNewsList] = useState(initialNews); // 新聞列表
  const [pageIndex, setPageIndex] = useState(1); // 頁碼

  // 取得更多專欄新聞
  const getMoreColumnNews = async () => {
    setLoadingMore(true);
    try {
      const result = await getColumnNewsByPage(locale, authorName, pageIndex);
      if (result) {
        setNewsList((prev) => [...prev, ...result.records]);
        setPageIndex((prev) => prev + 1);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setTimeout(() => {
        setLoadingMore(false);
      }, 300);
    }
  };

  return (
    <div>
      {/* 新聞列表 */}
      <section
        className="flex justify-start !items-start flex-wrap [&>*]:w-[calc((100%-40px)/3)] gap-y-[60px] gap-x-[20px]
      uxl:gap-y-[40px] ulg:[&>*]:w-[calc((100%-20px)/2)] usm:!gap-y-[30px] usm:block usm:[&>div]:w-full usm:space-y-[30px]"
      >
        {newsList?.map((news, i) => (
          <NewsComponent
            key={news?.id + "column-news" + i}
            news={news}
            t={t}
            location="list"
          />
        ))}
      </section>

      {/* 載入更多 */}
      {pageCnt > pageIndex && (
        <LoadMore onLoad={getMoreColumnNews} loadingMore={loadingMore} />
      )}
    </div>
  );
};

export default ColumnArticleList;
